import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import GradeBookGrades from 'modules/GradeBook/components/Grades';
import GradeBookFinaleGrades from 'modules/GradeBook/components/Grades/finaleGrade';
import GradeBookLessonInfo from 'modules/GradeBook/components/LessonInfo';
import store from 'store';

import ServiceRouter, { useServiceRouter } from '@common/components/ServiceRouter';
import assessmentTypes from '@common/constants/AssessmentTypesIds';
import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

import GradeBookLessonInfoComment from '../Comment';
import GBLessonStatus from '../Statuses';
import { StyledGradeBookLessonWrap } from './styled';

interface PropsType {
	gradeBook: IClientGradeBookModel;
	index: number;
	onSelectLesson?: (lesson: IClientGradeBookModel) => void;
}

function DayItem({ gradeBook, index, onSelectLesson }: PropsType) {
	const { t } = useTranslation();
	const { checkService } = useServiceRouter();
	const isTis = checkService('international');

	if (!gradeBook) {
		return null;
	}

	const assesmentType = gradeBook?.schedule_lesson?.lesson?.assessment_type_id;
	const weight = Math.round(parseFloat(gradeBook?.schedule_lesson?.lesson?.weight));
	const type = gradeBook?.schedule_lesson?.type;

	const showGrades = gradeBook.is_done === 2 && assesmentType !== 4;
	const isAasL = gradeBook?.schedule_lesson?.lesson?.assessment_type_id === 3;

	return (
		<StyledGradeBookLessonWrap
			role="button"
			onClick={() => onSelectLesson?.(gradeBook)}
			sx={{ cursor: onSelectLesson ? 'pointer' : 'default' }}
		>
			<Box
				sx={{ display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'space-between' }}
			>
				<Box
					sx={{
						display: 'flex',
						gap: '4px',
						alignItems: 'center',
					}}
				>
					<MediaTypography variant="caption1" color="#707070">{`${index}.`}</MediaTypography>
					{GBLessonStatus()[gradeBook?.is_present]}
				</Box>
				<GradeBookLessonInfoComment gradeBook={gradeBook} />
			</Box>

			<GradeBookLessonInfo
				title={gradeBook?.schedule_lesson?.schedule_program?.program_group?.program?.official_name}
				subTitle={gradeBook?.schedule_lesson?.name || gradeBook?.schedule_lesson?.lesson?.name}
				link={gradeBook?.schedule_lesson?.getZoomLink(store.services.current)}
				miroLink={gradeBook?.schedule_lesson?.schedule_program?.miro_link}
				gradeBook={gradeBook}
			/>
			{isTis && type && (
				<Box>
					<MediaTypography variant="body1" color="#fff">
						{type}
					</MediaTypography>
				</Box>
			)}
			{isTis && assesmentType && (
				<Box>
					<MediaTypography variant="body2" color="text.helper">
						{t('gradeBook.assesmentType')}
					</MediaTypography>
					<MediaTypography variant="body1">
						{assessmentTypes[assesmentType]}
						{assesmentType === 2 && weight && ` (${weight || 0}%)`}
					</MediaTypography>
				</Box>
			)}
			<ServiceRouter
				lyceum={
					<GradeBookGrades
						finaleGrade={showGrades && gradeBook.final_grade}
						grades={gradeBook.grades.filter((grade) => !!grade.gradeType?.id)}
					/>
				}
			>
				{showGrades && (
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
						<GradeBookFinaleGrades finaleGrade={isAasL ? 'Completed' : gradeBook.final_grade} />
					</Box>
				)}
			</ServiceRouter>
		</StyledGradeBookLessonWrap>
	);
}

export default observer(DayItem);
